<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
    <cf-google-sign-in
      v-if="isGoogleAuthEnabled"
      :type="authType"
    />

    <cf-facebook-sign-in v-if="isFacebookAuthEnabled" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfGoogleSignIn from '@/view/components/globals/cf-google-sign-in/index.vue';
  import CfFacebookSignIn from '@/view/components/globals/cf-facebook-sign-in/index.vue';


  export default {
    name: 'CfThirdPartyAuthentication',

    components: {
      CfGoogleSignIn,
      CfFacebookSignIn
    },

    props: {
      authType: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),

      isGoogleAuthEnabled() {
        return this.merchant.thirdPartySignIn.google;
      },

      isFacebookAuthEnabled() {
        return this.merchant.thirdPartySignIn.facebook;
      }
    }
  };
</script>
